var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"animal-item",class:_vm.dynamicTransition(),style:(_vm.stylePos)},[_c('img',{staticClass:"animal",attrs:{"src":_vm.imgSrc}})])}
var staticRenderFns = []

export { render, staticRenderFns }